var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0011 1.33325V7.99992C10.0011 8.73325 9.40114 9.33325 8.66781 9.33325H1.33447V3.99992C1.33447 2.52659 2.52781 1.33325 4.00114 1.33325H10.0011Z",
    stroke: "#4D83FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6678 9.33325V11.3333C14.6678 12.4399 13.7745 13.3333 12.6678 13.3333H12.0011C12.0011 12.5999 11.4011 11.9999 10.6678 11.9999C9.93447 11.9999 9.33447 12.5999 9.33447 13.3333H6.66781C6.66781 12.5999 6.06781 11.9999 5.33447 11.9999C4.60114 11.9999 4.00114 12.5999 4.00114 13.3333H3.33447C2.22781 13.3333 1.33447 12.4399 1.33447 11.3333V9.33325H8.66781C9.40114 9.33325 10.0011 8.73325 10.0011 7.99992V3.33325H11.2278C11.7078 3.33325 12.1478 3.59326 12.3878 4.00659L13.5278 5.99992H12.6678C12.3011 5.99992 12.0011 6.29992 12.0011 6.66659V8.66659C12.0011 9.03325 12.3011 9.33325 12.6678 9.33325H14.6678Z",
    stroke: "#4D83FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33431 14.6667C6.07069 14.6667 6.66764 14.0697 6.66764 13.3333C6.66764 12.597 6.07069 12 5.33431 12C4.59793 12 4.00098 12.597 4.00098 13.3333C4.00098 14.0697 4.59793 14.6667 5.33431 14.6667Z",
    stroke: "#4D83FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6678 14.6667C11.4042 14.6667 12.0011 14.0697 12.0011 13.3333C12.0011 12.597 11.4042 12 10.6678 12C9.93143 12 9.33447 12.597 9.33447 13.3333C9.33447 14.0697 9.93143 14.6667 10.6678 14.6667Z",
    stroke: "#4D83FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6676 8V9.33333H12.6676C12.301 9.33333 12.001 9.03333 12.001 8.66667V6.66667C12.001 6.3 12.301 6 12.6676 6H13.5276L14.6676 8Z",
    stroke: "#4D83FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCar);
export default __webpack_public_path__ + "static/media/blueCar.878315ecb53367f4ee6882c273426f00.svg";
export { ForwardRef as ReactComponent };